import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "../styles/NFTCard.css";
import Card from "./base/Card";
import CacheImage from "./base/CacheImage";
import { Colors } from "../constants/Colors";
import { getContractSeriesLabel } from "../lib/utils";

const CollectionCard = ({ collectionInfo, onClick }) => {
  const [colors, setColors] = useState([]);
  const getColors = colors => {
    setColors(c => [...c, ...colors]);
  }
  
  const contractSeries = getContractSeriesLabel(collectionInfo.contractAddress);
  
  return (
    <Card
      blurColor={colors[0]}
      onClick={onClick}
      aria-label={`Collection: ${collectionInfo.name} by ${collectionInfo.artistName}`}
      child={<>
        <CacheImage 
          imageID={collectionInfo.projectId * 1000000} 
          contractAddress={collectionInfo.contractAddress}
          getColors={getColors}
          projectId={collectionInfo.projectId}
        />
        <div className="wrapper">
          <div className="info-container">
            <p className="owner">{collectionInfo.artistName}</p>
            <p className="name">{collectionInfo.name}</p>
            <p style={{ 
              fontSize: '12px', 
              color: '#666', 
              marginTop: '4px',
              fontWeight: '500'
            }}>
              {contractSeries}
            </p>
          </div>

          <div className="price-container">
            <p className="price-label">Project Id</p>
            <p className="price">
              {" "}
              {collectionInfo.projectId}
            </p>
          </div>
        </div>
        <div className="buttons">
          {/* <Button color={Colors.buttons.primary} textContent="Buy Now" onClick={onClick} /> */}
          <div className="like-container">
            <p className="like-count">{collectionInfo.invocations}/{collectionInfo.maxInvocations} Minted</p>
          </div>
        </div>
      </>}>

    </Card>
  );
};

CollectionCard.propTypes = {
  collectionInfo: PropTypes.shape({
    projectId: PropTypes.number,
    name: PropTypes.string,
    artistName: PropTypes.string,
    invocations: PropTypes.number,
    maxInvocations: PropTypes.number,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CollectionCard;

